import axios from './axios';

let accessToken = localStorage.getItem('accessToken');
// console.log('Access token:', accessToken);

let userInfo = localStorage.getItem('userInfo');
// console.log('User info:', userInfo);

let accessTokenStudio = localStorage.getItem('accessTokenStudio');
let urlStudio = localStorage.getItem('urlStudio');

let accessTokenStream = localStorage.getItem('accessTokenStream');
let urlStream = localStorage.getItem('urlStream');

export const login = async (email, password) => {
    const res = await axios.post('/admin/login', { email_or_username: email, password });
    accessToken = res.data.token;
    userInfo = res.data?.data || null;
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('userInfo', buildUserInfo(userInfo));
    localStorage.removeItem('accessTokenStudio');
    localStorage.removeItem('urlStudio');
    localStorage.removeItem('accessTokenStream');
    localStorage.removeItem('urlStream');
    // console.log('Access token set:', accessToken);
    return true;
};

export const getAccessToken = () => accessToken;
export const getAccessTokenStudio = () => accessTokenStudio;
export const getStudioUrl = () => urlStudio;
export const getAccessTokenStream = () => accessTokenStream;
export const getStreamUrl = () => urlStream;

export const refreshToken = async () => {
    // console.log('Refreshing access token at:', new Date().toISOString());
    const res = await axios.put('/admin/login/refresh', {});
    accessToken = res.data.token;
    userInfo = res.data?.data || null;
    localStorage.setItem('accessToken', accessToken);
    localStorage.setItem('userInfo', buildUserInfo(userInfo));
    // console.log('Access token refreshed:', accessToken);
};

export const checkLogin = async () => {
    // console.log('Checking login status...');
    let success = false;
    try {
        const res = await axios.get('/admin/login/check', {});
        userInfo = res.data?.data || null;
        localStorage.setItem('userInfo', buildUserInfo(userInfo));
        success = true;
    }
    catch (error) {
        if (error.response && error.response.status === 401) {
            clearLogin();
        }
    }
    return success;
}

const buildUserInfo = (userInfo) => {
    if (userInfo) {
        userInfo.firstLetter = userInfo.name.charAt(0).toUpperCase();
        userInfo.isLoggedIn = true;
        const userInfoString = JSON.stringify(userInfo);
        return userInfoString;
    }
    return userInfo;
};

export const logout = async () => {
    await axios.post('/admin/logout', {});
    clearLogin();
    // console.log('Access token removed');
    // Opcional: logout backend, limpar cookies, etc.
};

export const getUserInfo = () => {
    userInfo = localStorage.getItem('userInfo');
    // console.log('Getting user info from localStorage', userInfo);
    if (userInfo) {
        const parsedUserInfo = JSON.parse(userInfo);
        return parsedUserInfo;
    }
    return {};
};

export const clearLogin = () => {
    // console.log('Clearing login data');
    accessToken = null;
    userInfo = null;
    accessTokenStudio = null;
    urlStudio = null;
    accessTokenStream = null;
    urlStream = null;
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userInfo');
    localStorage.removeItem('urlStudio');
    localStorage.removeItem('accessTokenStudio');
    localStorage.removeItem('urlStream');
    localStorage.removeItem('accessTokenStream');
}

export const refreshTokenStudio = async () => {
    // console.log('Refreshing access token studio at:', new Date().toISOString());
    const res = await axios.post('/admin/studio', {});
    accessTokenStudio = res.data?.data?.studio_token || null;
    urlStudio = res.data?.data?.studio_server_url || null;
    localStorage.setItem('accessTokenStudio', accessTokenStudio);
    localStorage.setItem('urlStudio', urlStudio);
    // console.log('Access token Studio refreshed:', accessTokenStudio);
};

export const refreshTokenStream = async () => {
    // console.log('Refreshing access token stream at:', new Date().toISOString());
    const res = await axios.post('/admin/stream', {});
    accessTokenStream = res.data?.data?.stream_token || null;
    urlStream = res.data?.data?.stream_server_url || null;
    localStorage.setItem('accessTokenStream', accessTokenStream);
    localStorage.setItem('urlStream', urlStream);
    // console.log('Access token Stream refreshed:', accessTokenStream);
};